import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Tooltip, Fade } from '@material-ui/core';  

//component:

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { createNewEmpresaDB, updateEmpresaDB, } from '../../actions/empresa_actions';
import * as config from '../../constants/configuration';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    buttonAtras: {
        margin: '0 0 10px 16px',
        height: 40,
        width: 123,
        padding: '10px 0',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formControl: {
        margin: '5px 0 5px 20px',
        height: 72,
        width: 185,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 600,
    },
    buttonsBottom: {
        margin: '60px 15px 30px 8px',
        padding: '10px 0',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EmpresaEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            empresa1: '',
            direccion1: '',
            direccion2: '',
            cp: '',
            localidad: '',
            pais: '',
            telfCentro: '',
            emailCentro: '',
            gerente: '',
            nif: '',
        };
    };

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        const empresaDetalles = this.props.empresas.find(e => e.id === parseInt(this.props.match.params.id));

        this.setState({
            id: empresaDetalles ? empresaDetalles.id : -1,
            empresa1: empresaDetalles ? !empresaDetalles.empresa1 ? '' : empresaDetalles.empresa1 : '',
            direccion1: empresaDetalles ? !empresaDetalles.direccion1 ? '' : empresaDetalles.direccion1 : '',
            direccion2: empresaDetalles ? !empresaDetalles.direccion2 ? '' : empresaDetalles.direccion2 : '',
            cp: empresaDetalles ? !empresaDetalles.cp ? '' : empresaDetalles.cp : '',
            localidad: empresaDetalles ? !empresaDetalles.localidad ? '' : empresaDetalles.localidad : '',
            pais: empresaDetalles ? !empresaDetalles.pais ? '' : empresaDetalles.pais : '',
            telfCentro: empresaDetalles ? !empresaDetalles.telfCentro ? '' : empresaDetalles.telfCentro : '',
            emailCentro: empresaDetalles ? !empresaDetalles.emailCentro ? '' : empresaDetalles.emailCentro : '',
            gerente: empresaDetalles ? !empresaDetalles.gerente ? '' : empresaDetalles.gerente : '',
            nif: empresaDetalles ? !empresaDetalles.nif ? '' : empresaDetalles.nif : '',
        })
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refresh !== this.props.refresh && this.props.refresh) {
            this.props.navigate("mae_empresa");
        };
    };

    handleValueChange = (event, field) => {
        this.props.setSaveState(true);
        this.setState({ ...this.state, [field]: event.target.value });
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvEmpresa = (emp) => {
        //email regular expression:
        var re = /[^@]+@[^@]+\.[^@]+/;

        if (this.props.empresas.find(elem => (elem.empresa1 === emp.empresa1) && (elem.id !== emp.id))) {
            this.messageDialog(`Ya existe una empresa ${emp.empresa1}`);
            return false;
        } else if (!emp.empresa1.trim()) {
            this.messageDialog('Por favor, rellene el campo Empresa');
            return false;
        } else if (emp.emailCentro && !re.test(emp.emailCentro)) {
            this.messageDialog('El Email introducido no es válido');
            return false;
        }

        else return true;

    };

    updateHandler = () => {
        const empresa = {
            id: this.state.id,
            empresa1: this.state.empresa1,
            direccion1: this.state.direccion1,
            direccion2: this.state.direccion2,
            cp: this.state.cp,
            localidad: this.state.localidad,
            pais: this.state.pais,
            telfCentro: this.state.telfCentro,
            emailCentro: this.state.emailCentro,
            gerente: this.state.gerente,
            nif: this.state.nif,
        };

        if (this.checkCvEmpresa(empresa)) {
            empresa.id === -1 ? this.props.createNewEmpresaDB(empresa) : this.props.updateEmpresaDB(empresa, this.props.match.params.id);
        }
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.toolbar} />
                {/* <Button className={classes.buttonAtras} variant="contained" color="secondary" onClick={() => this.props.navigate("mae_empresa")}>Atrás</Button> */}
                <form>

                    <div className={classes.containerPair}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'empresa1'}
                                label={'Empresa'}
                                placeholder={'Empresa'}
                                margin="normal"
                                autoFocus
                                value={this.state.empresa1}
                                onChange={(event) => this.handleValueChange(event, 'empresa1')}
                            />
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'direccion1'}
                                label={'Direccion 1'}
                                placeholder={'direccion 1'}
                                margin="normal"
                                value={this.state.direccion1}
                                onChange={(event) => this.handleValueChange(event, 'direccion1')}
                            />
                        </FormControl>
                    </div>

                    <div className={classes.containerPair}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'direccion2'}
                                label={'Direccion 2'}
                                placeholder={'direccion 2'}
                                margin="normal"
                                value={this.state.direccion2}
                                onChange={(event) => this.handleValueChange(event, 'direccion2')}
                            />
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'cp'}
                                label={'CP'}
                                placeholder={'cp'}
                                margin="normal"
                                value={this.state.cp}
                                onChange={(event) => this.handleValueChange(event, 'cp')}
                            />
                        </FormControl>


                    </div>

                    <div className={classes.containerPair}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'localidad'}
                                label={'Localidad'}
                                placeholder={'Localidad'}
                                margin="normal"
                                value={this.state.localidad}
                                onChange={(event) => this.handleValueChange(event, 'localidad')}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'pais'}
                                label={'País'}
                                placeholder={'País'}
                                margin="normal"
                                value={this.state.pais}
                                onChange={(event) => this.handleValueChange(event, 'pais')}
                            />
                        </FormControl>

                    </div>

                    <div className={classes.containerPair}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'telfCentro'}
                                label={'Teléfono'}
                                placeholder={'Teléfono'}
                                margin="normal"
                                value={this.state.telfCentro}
                                onChange={(event) => this.handleValueChange(event, 'telfCentro')}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'emailCentro'}
                                label={'Email'}
                                placeholder={'Email'}
                                margin="normal"
                                value={this.state.emailCentro}
                                onChange={(event) => this.handleValueChange(event, 'emailCentro')}
                            />
                        </FormControl>
                    </div>
                    <div className={classes.containerPair}>
                    <Tooltip title="Nombre del gerente" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'gerente'}
                                label={'Gerente'}
                                placeholder={'Gerente'}
                                margin="normal"
                                value={this.state.gerente}
                                onChange={(event) => this.handleValueChange(event, 'gerente')}
                            />
                        </FormControl>
                        </Tooltip>
                        
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'nif'}
                                label={'NIF'}
                                placeholder={'NIF'}
                                margin="normal"
                                value={this.state.nif}
                                onChange={(event) => this.handleValueChange(event, 'nif')}
                            />
                        </FormControl>
                    </div>
                </form>

                <div>
                    <Button className={classes.buttonsBottom} style={{ width: 127 }} variant="contained" color="secondary" onClick={() => this.props.navigate("mae_empresa")}>Atrás</Button>
                    <Button className={classes.buttonsBottom} style={{ width: 145 }} variant="contained" color="primary" onClick={() => this.updateHandler()}>Guardar</Button>
                </div>
            </div>
        );

    };

};

EmpresaEdit.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    empresas: PropTypes.array.isRequired,
    refresh: PropTypes.bool.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    updateEmpresaDB: PropTypes.func.isRequired,
    createNewEmpresaDB: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        empresas: state.empresas.empresas,
        refresh: state.empresas.refresh,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        openDialog,
        hideDialog,
        updateEmpresaDB,
        createNewEmpresaDB,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(EmpresaEdit)));
